import BaseMenuItem, {
  MenuItemProps as BaseMenuItemProps,
} from 'antd/lib/menu/MenuItem'

export interface MenuItemProps extends BaseMenuItemProps {}

export const MenuItem = (props: MenuItemProps): JSX.Element => (
  <>
    <BaseMenuItem {...props} />
  </>
)
